<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :top="true"
          :right="true"
          :timeout="6000"
          absolute
        >
          {{ message }}
          <v-btn dark text @click="snackbar = false"> CLOSE </v-btn>
        </v-snackbar>
        <v-layout row pb-1 mb-1>
          <v-spacer></v-spacer>
          <v-flex xs2>
            <v-btn
              rounded
              small
              color="secondary"
                class="accent--text logoutbtn"
              @click="generateInvoice"
              :disabled="canGenerateInvoice || processingRequest"
            >
              Send Transaction
            </v-btn>
            <v-progress-linear
              v-if="showProgressBar"
              indeterminate
            ></v-progress-linear>
          </v-flex>
        </v-layout>

        <v-layout row pb-1 mb-1>
          <!-- <v-flex xs2>
        <v-select
          v-model="selectedBrokerCode"
          :items="uniqueBrokerCodes"
          label="Broker Code"
          item-text="brokerCode"
          item-value="brokerCode"
          chips
          single
          clearable
        ></v-select>
      </v-flex> -->
          <v-layout>
            <v-flex xs3>
              <v-select
                v-model="selectedBrokerCode"
                :items="uniqueBrokerCodes"
                label="Select Broker Code"
                @input="filterByBrokerCode"
                item-text="brokerCode"
                item-value="brokerCode"
                style="background-color: white;margin-left: 10px;"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-layout>

        <v-data-table
          v-model="selected"
          :headers="headers"
          :items="brokerTransactions"
          show-select
          class="elevation-1"
        >
          <template v-slot:item.dateCreated="{ item }">
            {{ item.dateCreated | prettyDate }}
          </template>
        </v-data-table>
        <!-- Loading Overlay -->
        <v-overlay :value="loadingPage">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import config from "../../../config";

export default {
  name: "buyerinvoices",
  data: function () {
    return {
      headers: [
        { text: "Eslip Number", value: "eslipNumber" },
        { text: "Broker Amount", value: "brokerAmount" },
        { text: "CleanCoffee", value: "cleanCoffeeOutTurn" },
        { text: "ParchmentOutturn", value: "parchmentOutTurn" },
        { text: "Grower Code", value: "growerCode" },
        // { text: "Eslip Amount", value: "eslipAmount" },
        { text: "Broker Code", value: "brokerCode" },
        { text: "Nce Amount", value: "nceAmount" },
        { text: "Status", value: "status.statusName" },
        { text: "DateCreated", value: "dateCreated" },
      ],
      //   selectedBrokerCode: [],
      selectedBrokerCode: null,
      brokerTransactions: [],
      originalBrokerPayments: [],
      uniqueBrokerCodes: [],
      message: "",
      error: "",
      loading: false,
      loadingPage: false,
      pagination: {
        sortBy: "name",
      },
      totalData: 0,
      snackbar: false,
      snackbarColor: "",
      messsage: "",
      editedItem: {
        id: "",
        lotNumber: "",
        saleNumber: "",
        buyerCode: "",
        price: "",
      },
      defaultItem: {
        id: "",
        lotNumber: "",
        saleNumber: "",
        buyerCode: "",
        price: "",
      },
      selected: [],
      rejectInvoice: { marketer: {}, totalValue: "" },
      rejectDialog: false,
      processingRequest: false,
      showProgressBar: false,
    };
  },
  mounted() {
    this.getDataFromApi();
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi().then((data) => {
          // this.users = data.items
          // this.totalUsers = data.total
        });
      },
      deep: true,
    },
  },
  // Watch for changes in selectedBrokerCode and load data accordingly
  selectedBrokerCode: function (newValue) {
    // Check if a broker code is selected
    if (newValue !== null) {
      console.log("Broker Code selected:", newValue);

      // Make API request using the selected broker code
      this.loadDataFromApi(newValue);
    }
  },

  computed: {

    canGenerateInvoice: function () {
      if (this.selected.length === 0 || this.processingRequest) {
        return true; // Disable the button if nothing is selected or a request is being processed
      } else {
        return false; // Enable the button if there are selected records and no request is being processed
      }
    },
  },
  methods: {
    showErrorDialog() {
    this.snackbar = true;
    this.snackbarColor = 'error';
    this.message = 'Select records with the same Broker Code and amount must be greater than 10';
  },
    handleRequestError(error, errorMessage) {
      console.error(errorMessage);
      console.error(error);

      // Add your custom error handling logic here, such as displaying a snackbar or alert
      this.snackbar = true;
      this.snackbarColor = "error";
      this.message = errorMessage || "An error occurred";
    },
    async filterByBrokerCode() {
  try {
    if (this.selectedBrokerCode) {
      const apiEndpoint = `${config.serverURI}/brokerTransaction/getAll/${this.selectedBrokerCode}`;
      const response = await axios.get(apiEndpoint);

      // Update brokerTransactions with the response data
      this.brokerTransactions = response.data;

      // Update uniqueBrokerCodes based on the filtered brokerTransactions
      this.uniqueBrokerCodes = [
        ...new Set(
          this.brokerTransactions.map((item) => item.brokerCode)
        ),
      ];
    } else {
      // If no broker code is selected, reset to original data
      this.brokerTransactions = [...this.originalBrokerPayments];

      // Update uniqueBrokerCodes based on the original data
      this.uniqueBrokerCodes = Array.from(
        new Set(this.brokerTransactions.map((item) => item.brokerCode))
      ).map((code) => ({ brokerCode: code }));
    }
  } catch (error) {
    this.handleRequestError(
      error,
      "Error occurred while fetching payments"
    );
  }
},

    // async filterByBrokerCode() {
    //   try {
    //     if (this.selectedBrokerCode) {
    //       const apiEndpoint = `${config.serverURI}/brokerTransaction/getAll/${this.selectedBrokerCode}`;
    //       const response = await axios.get(apiEndpoint);

    //       // Update brokerTransactions with the response data
    //       this.brokerTransactions = response.data;

    //       // Update uniqueBrokerCodes based on the filtered brokerTransactions
    //       this.uniqueBrokerCodes = [
    //         ...new Set(
    //           this.originalBrokerPayments.map((item) => item.brokerCode)
    //         ),
    //       ];
    //     } else {
    //       // If no broker code is selected, reset to original data
    //       this.brokerTransactions = [...this.originalBrokerPayments];

    //       // Update uniqueBrokerCodes based on the original data
    //       this.uniqueBrokerCodes = Array.from(
    //         new Set(this.originalBrokerPayments.map((item) => item.brokerCode))
    //       ).map((code) => ({ brokerCode: code }));
    //     }
    //   } catch (error) {
    //     this.handleRequestError(
    //       error,
    //       "Error occurred while fetching payments"
    //     );
    //   }
    // },
    rejectInvoiceDialog(item) {
      this.rejectDialog = true;
      this.rejectInvoice = item;
    },
    closeInvoiceDialog() {
      this.rejectInvoice = { marketer: {}, totalValue: "" };
      this.rejectDialog = false;
    },
    rejectInvoiceFunction() {
      const url = config.serverURI + "/invoice/reject";
      axios
        .post(url, this.rejectInvoice)
        .then((response) => {
          this.snackbar = true;
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbarColor = "error";
            return;
          }
          this.brokerTransactions = this.getBuyerInvoices();
          this.message = response.data.message;
          this.snackbarColor = "primary";
        })
        .catch((error) => {
          var data = error.response.data;
          this.message = data.status;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
      this.closeInvoiceDialog();
    },
    requestEslipDialog(item) {
      this.editedIndex = this.brokerTransactions.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save() {
      this.sendRequest();
      this.close();
    },
    sendRequest() {
      const url = config.serverURI + "/invoice/requesteslip";
      axios
        .post(url, this.editedItem)
        .then((response) => {
          this.snackbar = true;
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbarColor = "error";
            return;
          }
          this.brokerTransactions = this.getBuyerInvoices();
          this.message = response.data.message;
          this.snackbarColor = "primary";
        })
        .catch((error) => {
          var data = error.response.data;
          this.message = data.status;
          this.snackbarColor = "error";
          this.snackbar = true;
        });
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let items = this.getBuyerInvoices();

        // Check if items is an array before attempting to sort
        if (!Array.isArray(items)) {
          items = []; // Provide a default value if it's not an array
        }

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy];
            const sortB = b[sortBy];

            if (descending) {
              if (sortA < sortB) return 1;
              if (sortA > sortB) return -1;
              return 0;
            } else {
              if (sortA < sortB) return -1;
              if (sortA > sortB) return 1;
              return 0;
            }
          });
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage);
        }

        setTimeout(() => {
          this.loading = false;
          resolve({
            items,
            total: items.length, // Assuming total is based on the length of the items array
          });
        }, 1000);
      });
    },

    toggleSelect(props) {
    if (props.item.status === 1) {
      // Check if selected items have the same brokerCode
      const selectedBrokerCodes = this.selected.map(item => item.brokerCode);
      if (selectedBrokerCodes.length === 0 || selectedBrokerCodes.includes(props.item.brokerCode)) {
        props.selected = !props.selected;
      } else {
        this.showErrorDialog();
      }
    }
  },

  generateInvoice() {
    if (this.selected.length === 0) {
      this.showErrorDialog();
      return;
    }

    const selectedBrokerCodes = this.selected.map(item => item.brokerCode);
    console.log('Selected codes',selectedBrokerCodes)
    const sumBrokerAmount = this.selected.reduce((sum, item) => sum + item.brokerAmount, 0)
    if (selectedBrokerCodes.every(code => code === selectedBrokerCodes[0])&& sumBrokerAmount > 10) {
  // Proceed with generating invoices
  this.processingRequest = true;
  this.showProgressBar = true;
  this.sendGenerateInvoiceRequest();
} else {
  // Show an error dialog if there are multiple unique brokerCodes
  this.showErrorDialog();
  this.selected=[];
}


    // Check if all selected items have the same brokerCode
    // if (selectedBrokerCodes.length === 1) {
    //   this.processingRequest = true;
    //   this.showProgressBar = true;
    //   this.sendGenerateInvoiceRequest();
    // } else {
    //   this.showErrorDialog();
    // }
  },
  getBuyerInvoices() {
  // Set the loading flag before making the request
  this.loadingPage = true;

  var url = config.serverURI + "/brokerTransaction/getAll";

  return axios
    .get(url)
    .then((response) => {
      // Reset the loading flag after the request is complete
      this.loadingPage = false;

      console.log('Broker Transactions', response.data)

      // Update the invoices data
      this.brokerTransactions = response.data;
      this.originalBrokerPayments = [...this.brokerTransactions]; // Store the original list

      // Filter the invoices based on the status
      this.brokerTransactions = this.brokerTransactions.filter(
        (invoice) => invoice.status.id === 5 && invoice.nonCheckOffPaymentstatus === 7
      );

      // Update uniqueBrokerCodes based on the filtered brokerTransactions
      this.uniqueBrokerCodes = Array.from(
        new Set(this.brokerTransactions.map((item) => item.brokerCode))
      ).map((code) => ({ brokerCode: code }));

      return this.brokerTransactions; // Return the data for further use
    })
    .catch((error) => {
      // Reset the loading flag after the request is complete
      this.loadingPage = false;

      // Handle errors appropriately (log or display a message)
      console.log("error", error.response);
      this.message = error.response;
      this.snackbar = true;
      this.snackbarColor = "error";

      // Return an empty array or another appropriate value
      return [];
    });
},


    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        const result = this.brokerTransactions.filter((sel) => {
          // eslint-disable-next-line
          return sel.status.id == 1;
        });
        this.selected = result.slice();
      }
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    // generateInvoice() {
    //   this.processingRequest = true;
    //   this.showProgressBar = true;
    //   // this.loadingPage = true
    //   console.log(this.selected);
    //   this.sendGenerateInvoiceRequest();
    // },
    sendGenerateInvoiceRequest() {
      const url = config.serverURI + "/eslip/approveBrokerage";
      axios
        .post(url, this.selected)
        .then((response) => {
          this.snackbar = true;
          if (response.data.error !== false) {
            this.message = response.data.message;
            this.snackbarColor = "error";
            return;
          }
          this.message = response.data.message;
          this.snackbarColor = "primary";
          this.selected = [];
          this.getBuyerInvoices();
        })
        .catch((error) => {
          var data = error.response.data;
          this.message = data.status;
          this.snackbarColor = "error";
          this.snackbar = true;
        })
        .finally(() => {
          this.processingRequest = false;
          this.showProgressBar = false;
          // this.loadingPage = false
        });
    },
    triggerDownload(item) {
      var url = config.serverURI + "/invoice/download/" + item.id;
      axios
        .get(url)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const itemFileName =
            item.marketer.organisationName + "_" + item.created;
          link.setAttribute("download", itemFileName);
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          // Request failed.
          console.log("error", error.response);
          this.message = error.response.status;
          this.snackbar = true;
          this.snackbarColor = "error";
        });
      return this.brokerTransactions;
    },
  },
};
</script>
<style>
.text {
  font-style: "Open Sans";
  font-size: 16px;
  color: #000;
}
</style>
